var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 24 / icon_check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7175 6.61084C19.5223 6.41558 19.2057 6.41558 19.0104 6.61084L10.8787 14.7426L6.98961 10.8535C6.79435 10.6582 6.47777 10.6582 6.2825 10.8535L4.86829 12.2677C4.67303 12.463 4.67303 12.7795 4.86829 12.9748L9.11093 17.2174L10.5251 18.6317C10.7204 18.8269 11.037 18.8269 11.2323 18.6317L12.6465 17.2174L21.1317 8.73216C21.327 8.5369 21.327 8.22032 21.1317 8.02506L19.7175 6.61084Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.937da90e28fe978fdfa943e1e96a99ef.svg";
export { ForwardRef as ReactComponent };